<div class="aca-page-header__tile" *ngIf="icon() && !bare()" aria-hidden="true">
  <mat-icon>{{ icon() }}</mat-icon>
</div>

<div class="aca-page-header__text" *ngIf="!bare()">
  <h1 class="aca-page-header__title">{{ title() }}</h1>
  <p class="aca-page-header__subtitle" *ngIf="subtitle()">{{ subtitle() }}</p>
</div>

<div class="aca-page-header__actions">
  <ng-content />
</div>
